import styled from '@emotion/styled';
import React, { useRef } from 'react';
import EmptyReview from '../../common/EmptyReview';
import CompletedCard from '../../ReviewCard/Completed';
import CompletedSkeleton from '../../ReviewSkeleton/CompletedSkeleton';
import { review_page_common_style } from '../../styles';
import Text from 'components/base/Text';
import { useCompletedReviewList } from 'components/my-page/hooks';
import useIntersectionObserver from 'hooks/useIntersectionObserver';
import { FBK_SITE_ID } from 'util/constant';

/**
 * 마이페이지 [리뷰] - 작성한 리뷰탭
 * @component
 */
const Completed = () => {
  const loading_ref = useRef<HTMLDivElement>(null);
  const { my_review_list, total_count, is_loading, has_next_page, fetchNextPage } = useCompletedReviewList();

  useIntersectionObserver(
    {
      target: loading_ref,
      onIntersect: fetchNextPage,
      enabled: has_next_page,
      rootMargin: '200px',
    },
    [has_next_page],
  );

  if (is_loading) {
    return <CompletedSkeleton />;
  }

  if (total_count === 0) {
    return (
      <SC.EmptyWrapper>
        <EmptyReview title='작성한 리뷰가 없습니다.' text='상품을 구매하고 리뷰를 작성해 보세요.' />
      </SC.EmptyWrapper>
    );
  }

  /**
   *  TODO: product_review_list 쿼리에 site_id 인자 추가되기 전까지 클라이언트에서 필터링 및 total_count 미노출 처리
   */
  return (
    <SC.Container css={review_page_common_style} >
      <div className='text_info'>
        <Text variant='title6_medium' color='gray_secondary'>
          작성한 리뷰
          {/* <label className='review_count'>{total_count}</label> */}
        </Text>
      </div>
      <div className='review_list'>
        {my_review_list
          .filter((item) => item.review_info.site_id === FBK_SITE_ID)
          .map((item, index) => (
            <CompletedCard key={index} item_info={item} is_last={index === my_review_list.length - 1} />
          ))}
      </div>
      {has_next_page && (
        <SC.LoadingContainer ref={loading_ref}>
          <CompletedSkeleton />
        </SC.LoadingContainer>
      )}
    </SC.Container>
  );
};

export default Completed;

const SC = {
  Container: styled.div`
    padding-top: 92px;
  `,
  EmptyWrapper: styled.div`
    padding-top: 92px;
  `,
  LoadingContainer: styled.div`
    & > div {
      padding: 0px 16px 16px;
    }
  `,
};
